import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SupplementaryEquipmentAdministrationComponent } from './component/supplementary-equipment.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule, TableSelectionDialogModule } from '@sdbn/appclient';

import { ApplicationClientCommonModule } from '@sdbn/appclient';
import { DictionaryModule } from '@sdbn/appclient';
import { CommonTranslationModule, CommonUIModule } from '@sdbn/common';
import { TransportOptionsPanelModule } from 'src/tmc-yard/components/transport-options-panel/transport-options-panel.module';
import { EquipmentIdentifierComponent } from './component/equipment-identifier/equipment-identifier.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    TableSelectionDialogModule,
    ApplicationClientCommonModule,
    CommonTranslationModule,
    CommonUIModule,
    TransportOptionsPanelModule,
    DictionaryModule
  ],
  declarations: [
    SupplementaryEquipmentAdministrationComponent,
    EquipmentIdentifierComponent

  ]
})
export class SupplementaryEquipmentAdministrationModule { }
